module.exports = __webpack_public_path__ + "static/media/logout.2da67b1f.svg";